<template>
  <BaseTemplate>
    <block>
      <h1>コード認証に失敗しました</h1>
      <div class="memo"><span>×</span>認証コードが一致しません。</div>
      <div class="block sms_block">
        <BlackGradationButton
          class="label-input nomt sms_button"
          className="small"
          text="認証コード入力画面へ"
          @handleSquareBtnClick="btnBackCodePage" />
      <BlackGradationButton
        class="label-input nomt sms_button hanten"
        className="small"
        text="電話番号入力画面へ"
        @handleSquareBtnClick="btnBackTelPage" />
      </div>
    </block>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  components: {
    BaseTemplate,
    BlackGradationButton,
  },

  data: () => ({
    pageMode: 0,
  }),

  methods: {
    btnBackCodePage() {
      this.$router.push({ path: '/sms', query: { pageMode: 1 } });
    },
    btnBackTelPage() {
      this.$router.push({ path: '/sms', query: { pageMode: 0 } });
    },
  },
};
</script>

<style lang="scss" scoped>
block {
  margin: 40px auto 200px auto;
  max-width: 800px;
  display: block;
  @media screen and  (max-width: $tabletWidth) {
    padding: 0 20px;
  }
  h1 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  .memo {
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
    border: solid 1px #fc615f;
    color: #fc615f;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding: 10px 10px;
    span {
      border: solid 2px #fc615f;
      border-radius: 100px;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
    }
  }
  .block {
    padding: 20px 20px;
    .label {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .sms_button {
      width: 240px;
      padding: 10px 0;
      margin: 20px auto 20px auto;
    }
  }
}
</style>
